import { Controller, useForm } from 'react-hook-form';
import { JSX, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
// import '../UpdateProfile/UpdateProfile.scss';
import captcha_img from './captcha_img.jpg';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
// import Header from '../Header/TopHeader';
import { Breadcrumb, Col, Form, Input, Layout, Menu, Row, theme, Typography, Button, Card, Divider, Spin, } from 'antd';
import { Field, FieldProps, Formik } from 'formik';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import UserHeader from '../UserHeader';
import UserNavbar from '../UserNavbar';
import { Footer } from 'antd/es/layout/layout';
import { BackendAPI } from '../../../axios';
import { LoadingOutlined, } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const { Header, Content, Sider } = Layout;
const { Title } = Typography;
const MySwal = withReactContent(Swal);
const THEME_COLOR = "#1515b4";

// interface updateForm {
//     cd_name: string;
//     cd_designation: string;
//     cdemail: string;
//     phone: string;
// }

interface PageSettingsProps {
    isDarkMode: boolean;
}
const validationSchema = Yup.object().shape({
    cd_name: Yup.string().required('Name is required'),
    cd_designation: Yup.string().required('Designation is required'),
    cd_email: Yup.string().email('Invalid email').required('Email is required'),
    cd_mobile: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits').required('Mobile number is required'),
    phone: Yup.string()
    .matches(/^[0-9]{10,11}$/, 'Phone number must be 10 or 11 digits').required('Phone number is required'),
});


export default function UpdateProfile(): JSX.Element {
    const userfromstore = useSelector((state: RootState) => state.user.user);
    console.log(userfromstore);
    const navigate = useNavigate();
    const location = useLocation();
    const [isOnClickSlider, setOnclickSlider] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 830);
    const [formInitialValues, setFormInitialValues] = useState({
        organizationName: '',
        organizationType: '',
        dept: '',
        registartion_no: '',
        department: '',
        ministry: '',
        city: '',
        pincode: '',
        address: '',
        phone: '',
        service_type: '',
        project_description: '',
        project_purpose: '',
        quarterly_transaction_count: '',
        sa_code: '',
        username: '',
    });

    const handleLogout = async () => {
        try {
            const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

            if (response.status === 200) {
                localStorage.removeItem("authToken");
                localStorage.removeItem("initialTime");
                localStorage.removeItem("lastSavedTime");
                localStorage.removeItem("remainingTime");
                navigate("/");
            }
        } catch (error) {
        }
    };
    let refreshToken: null;

    const getRefreshToken = async () => {
        try {
            const response = await BackendAPI.get("/user/refresh-token", { withCredentials: true });
            refreshToken = response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    window.location.reload();
                }
            }
            console.error("Error retrieving token:", error);
        }
    };

    const { control, handleSubmit, formState: { errors, touchedFields, isSubmitted } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });

    const onSubmit = async (data: any) => {
        setLoading(true);
        // const refreshToken = null;
        await getRefreshToken();
        const url = `/user/update`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
        };
        try {
            const response = await BackendAPI.put(url, data, header);
            if (response.data === 'User information updated successfully') {
                MySwal.fire({
                    icon: 'success',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'Profile Updated!',
                    text: 'Your user information has been updated successfully.',
                    confirmButtonColor: "#4CAF50",
                    confirmButtonText: "OK",
                });
            } else if (response.data === 'Email is already in use') {
                MySwal.fire({
                    icon: 'error',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'Email Already in Use!',
                    text: 'The email address you entered is already in use. Please try a different one.',
                    confirmButtonColor: "#d33",
                    confirmButtonText: "Try Again",
                });
            }
            setLoading(false);
        } catch (error) {
            let errorMessage = "Something went wrong. Please try again later."; // Default error message
            if (axios.isAxiosError(error)) {
                if (error.request) {
                    // Server responded with a status code outside 2xx range
                    if (error.request.status === 400) {
                        errorMessage = "Invalid request. Please check the entered details.";
                    } else if (error.request.status === 401) {
                        errorMessage = "Unauthorized access! Please log in again.";
                        handleLogout();
                    } else if (error.request.status === 403) {
                        errorMessage = "You do not have permission to perform this action.";
                    } else if (error.request.status === 404) {
                        errorMessage = "Requested resource not found!";
                    } else if (error.request.status === 500) {
                        errorMessage = "Server error! Please try again later.";
                    } else {
                        errorMessage = error.request.data?.message || "Something went wrong.";
                    }
                    MySwal.fire({
                        icon: 'error',
                        imageWidth: 100,
                        imageHeight: 100,
                        title: 'Error',
                        text: errorMessage,
                    });
                }
            }
            MySwal.fire({
                icon: 'error',
                imageWidth: 100,
                imageHeight: 100,
                title: 'Error Occurred!',
                text: errorMessage,
                confirmButtonColor: "#d33",
                confirmButtonText: "OK",
            });
            setLoading(false);
        }
    };

    const labelStyle = {
        color: "#000000", // White for dark mode, black for light mode
        fontWeight: "bold",
        // marginBottom: "8px",
    };
    const handleCollapse = (value: any) => {
        setCollapsed(value);
        setOnclickSlider(!isOnClickSlider);
    };

   /* const getUserInfo = async () => {
        const url = `/user/info`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
        };
        try {
            const response = await BackendAPI.get(url, header);
            setFormInitialValues(response.data);
            // setStatus(response.data);
        } catch (error) {
            let errorMessage = "Something went wrong. Please try again later.";
            if (axios.isAxiosError(error)) {
                if (error.request) {
                    // Server responded with a status code outside 2xx range
                    if (error.request.status === 400) {
                        errorMessage = "Invalid request. Please check the entered details.";
                    } else if (error.request.status === 401) {
                        errorMessage = "Unauthorized access! Please log in again.";
                        handleLogout();
                    } else if (error.request.status === 403) {
                        errorMessage = "You do not have permission to perform this action.";
                    } else if (error.request.status === 404) {
                        errorMessage = "Requested resource not found!";
                    } else if (error.request.status === 500) {
                        errorMessage = "Server error! Please try again later.";
                    } else {
                        errorMessage = error.request.data?.message || "Something went wrong.";
                    }
                    MySwal.fire({
                        icon: 'error',
                        imageWidth: 100,
                        imageHeight: 100,
                        title: 'Error',
                        text: errorMessage,
                    });
                }
            }
        }
    };*/
   
   /* useEffect(() => {
        const executeFunctions = async () => {
            await getRefreshToken();
            await getUserInfo();
        };
        executeFunctions();
    }, []);*/
     
    
    //setFormInitialValues(userfromstore);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 830);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);
    return (
        <>
            {loading && (
                <Spin spinning={true} style={{ position: 'absolute', top: '50%', left: '50%', zIndex: 9999 }} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            )}
            {/* <div>
                <UserHeader setIsOnClickSlider={setOnclickSlider} />
            </div> */}
            <Layout style={{ minHeight: '89vh', }}>

                <Sider
                    // collapsed={isOnClickSlider}
                    collapsed={isMobile ? true : isOnClickSlider}
                    collapsedWidth={50}
            style={{
                        // height: '90vh',
                        background: 'white',
                        position: 'relative',
                        overflow: 'auto',
                        top: '0px',
                        paddingTop: '20px',
                    }}
                >
                    {/* Custom collapse icon at top */}

                    <div style={{ top: '0', position: 'sticky', height: '100%', }}>
                        {/* Add menu or other content here */}
                        {/* <div
                            style={{
                                position: 'absolute',
                                top: 0, textAlignLast: 'right',
                                cursor: 'pointer', width: '100%', padding: '6px 16px',
                            }}
                            onClick={handleCollapse}
                        >
                            {collapsed ? <MenuUnfoldOutlined style={{ fontSize: '30px', }} /> : <MenuFoldOutlined style={{ fontSize: '30px', }} />}
                        </div> */}
                        <UserNavbar />
                        {/* <div style={{ textAlignLast: 'center', transition: 'all 0.9s', display: isOnClickSlider ? 'none' : 'block', position: 'absolute', justifySelf: 'center', bottom: '2%', }}>
                            <img src={cdac_logo} alt="Status" style={{ width: '40%', height: 'auto' }} />
                            <h5 style={{ textAlign: 'center', margin: '0' }}>Center for Development of Advanced Computing (C-DAC)</h5>
                        </div> */}
                    </div>
                </Sider>
                <Layout>
                    <Content style={{ margin: '16px 16px 0', overflowY: 'auto', maxHeight: 'calc(100vh - 80px)', paddingBottom: 32 }}>
                        <div style={{ width: '100%', justifyItems: 'center', }}>
                            {/* <Title level={2} style={{ alignSelf: 'self-start', padding: '0px 10px', margin: '10px 0px !important' }}>
                                Organization Details
                            </Title> */}
                            <Title
                                    level={3}
                                    style={{
                                        color: THEME_COLOR,
                                        borderBottom: `3px solid ${THEME_COLOR}`,
                                        display: "inline-block",
                                        paddingBottom: 6,
                                        marginBottom: 32,
                                    }}
                                >
                                    Organization Details
                                </Title>
                            <div style={{
                                width: '100%',
                                justifyItems: 'center',
                                // border: '2px solid #2c56ff',
                                borderRadius: '10px'
                            }}>

                                <Card style={{ marginTop: '10px', width: '100%', padding: '5px 25px', }} >
                                    <Divider style={{ color: '#1515b4', fontWeight: 'bold', fontSize: '20px' }}>Organization Information</Divider>
                                    <Form layout="vertical"
                                    // initialValues={formInitialValues}
                                    // initialValues={{
                                    //     organizationName: `${formInitialValues.organizationName}`,
                                    //     organizationType: "Central",
                                    //     department: "ESIC",
                                    //     ministry: "Home Ministry",
                                    //     city: "Delhi",
                                    //     pincode: "110001",
                                    //     address: "Shastri Park, New Delhi, Delhi 110053",
                                    //     phone: "02256545562",
                                    // }}
                                    >
                                        <Row gutter={16}>
                                            {/* Input 1 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Organization Name</span>}
                                                // name="organizationName"  

                                                >
                                                    <Input value={userfromstore?.organizationName} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                            {/* Input 2 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Organization Type</span>}
                                                // name="organizationType"
                                                >
                                                    <Input value={userfromstore?.organizationType} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            {/* Input 1 */}
                                            {((formInitialValues.organizationType === 'central' || formInitialValues.organizationType === 'state') &&
                                                <Col xs={24} md={12}>
                                                    <Form.Item label={<span style={labelStyle}>Department</span>}
                                                        name="department"
                                                    >
                                                        {/*<Input value={formInitialValues.dept} style={{ color: 'black', }} disabled />*/}
                                                        <Input value={userfromstore?.dept} style={{ color: 'black', }} disabled />
                                                    </Form.Item>
                                                </Col>
                                            )}
                                            {/* Input 2 */}
                                            {((userfromstore?.organizationType === 'central' || userfromstore?.organizationType === 'state') &&
                                                <Col xs={24} md={12}>
                                                    <Form.Item label={<span style={labelStyle}>Ministry</span>}
                                                    // name="ministry"
                                                    >
                                                        <Input value={userfromstore.ministry} style={{ color: 'black', }} disabled />
                                                    </Form.Item>
                                                </Col>
                                            )}
                                            {(userfromstore?.organizationType === 'private' &&
                                                <Col xs={24} md={12}>
                                                    <Form.Item label={<span style={labelStyle}>Registration Number</span>}
                                                    //    name="registartion_no"
                                                    >
                                                        <Input value={userfromstore.registrationNo} style={{ color: 'black', }} disabled />
                                                    </Form.Item>
                                                </Col>
                                            )}


                                            {/* Input 1 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Address</span>}
                                                // name="address"
                                                >
                                                    <Input value={userfromstore?.address} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>

                                            {/* Input 2 */}
                                            <Col xs={24} md={8}>
                                                <Form.Item label={<span style={labelStyle}>Pincode</span>}
                                                // name="pincode"
                                                >
                                                    <Input value={userfromstore?.pincode} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>

                                            {/* Input 1 */}
                                            <Col xs={24} md={8}>
                                                <Form.Item label={<span style={labelStyle}>  City</span>}
                                                // name="city"
                                                >
                                                    <Input value={userfromstore?.city} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                            {/* Input 2 */}
                                            <Col xs={24} md={8}>
                                                <Form.Item label={<span style={labelStyle}>Mobile/LandLine(With STD Code)</span>}
                                                // name="phone"
                                                >
                                                    <Input value={userfromstore?.phone} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card>
                                <Card style={{ marginTop: '20px', width: '100%', padding: '5px 25px', }} >
                                    <Divider style={{ color: '#1515b4', fontWeight: 'bold', fontSize: '20px' }}>Service Details</Divider>
                                    <Form layout="vertical"
                                        initialValues={{
                                            service_type: "AUA",
                                            project_description: "ORGI Home ministry project",
                                            project_purpose: "For authentication",
                                            quarterly_transaction_count: "65434",
                                            sub_aua_code: "ORGI2432",
                                            username: "SUB2432",
                                        }}>
                                        <Row gutter={16}>
                                            {/* Input 1 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Service Requested</span>}
                                                // name="service_type"
                                                >
                                                    <Input value={userfromstore?.serviceType?.toUpperCase()} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                            {/* Input 2 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Project Description</span>}
                                                // name="project_description"
                                                >
                                                    <Input value={userfromstore?.projectDescription} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            {/* Input 1 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Project Purpose</span>}
                                                // name="project_purpose"
                                                >
                                                    <Input value={userfromstore?.projectPurpose} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                            {/* Input 2 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Expected Quarterly Transactions</span>}
                                                // name="quarterly_transaction_count"
                                                >
                                                    <Input value={userfromstore?.quarterlyTransactionCount} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            {/* Input 1 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>SUB-AUA Code</span>}
                                                // name="sub_aua_code"
                                                >
                                                   <Input value={userfromstore?.sacode == null ? 'NOT GENERATED' : userfromstore?.sacode} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                            {/* Input 2 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item label={<span style={labelStyle}>Username</span>}
                                                // name="username"
                                                >
                                                    <Input value={userfromstore?.username} style={{ color: 'black', }} disabled />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card>
                                <Card style={{ margin: '20px 0px', width: '100%', padding: '5px 25px', }} >
                                    <Divider style={{ color: '#1515b4', fontWeight: 'bold', fontSize: '20px' }}>Contact Person Details</Divider>
                                    <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
                                        <Row gutter={16}>
                                            {/* Input 1 */}
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label={<span style={labelStyle}>Name <span style={{ color: 'red' }}>*</span></span>}
                                                    validateStatus={errors.cd_name ? 'error' : ''}
                                                    help={(touchedFields.cd_name || isSubmitted) && errors.cd_name ? errors.cd_name.message : ''}
                                                >
                                                    <Controller
                                                        name="cd_name"
                                                        control={control}
                                                        render={({ field }) => <Input {...field} />}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label={<span style={labelStyle}>Designation <span style={{ color: 'red' }}>*</span></span>}
                                                    validateStatus={errors.cd_designation ? 'error' : ''}
                                                    help={(touchedFields.cd_designation || isSubmitted) && errors.cd_designation ? errors.cd_designation.message : ''}
                                                >
                                                    <Controller
                                                        name="cd_designation"
                                                        control={control}
                                                        render={({ field }) => <Input {...field} />}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label={<span style={labelStyle}>Email <span style={{ color: 'red' }}>*</span></span>}
                                                    validateStatus={errors.cd_email ? 'error' : ''}
                                                    help={(touchedFields.cd_email || isSubmitted) && errors.cd_email ? errors.cd_email.message : ''}
                                                >
                                                    <Controller
                                                        name="cd_email"
                                                        control={control}
                                                        render={({ field }) => <Input type="email" {...field} />}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label={<span style={labelStyle}>Mobile Number <span style={{ color: 'red' }}>*</span></span>}
                                                    validateStatus={errors.cd_mobile ? 'error' : ''}
                                                    help={(touchedFields.cd_mobile || isSubmitted) && errors.cd_mobile ? errors.cd_mobile.message : ''}
                                                >
                                                    <Controller
                                                        name="cd_mobile"
                                                        control={control}
                                                        render={({ field }) => <Input {...field} placeholder='Enter Mobile Number' />}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label={<span style={labelStyle}>Telephone <span style={{ color: 'red' }}>*</span></span>}
                                                    validateStatus={errors.phone ? 'error' : ''}
                                                    help={(touchedFields.phone || isSubmitted) && errors.phone ? errors.phone.message : ''}
                                                >
                                                    <Controller
                                                        name="phone"
                                                        control={control}
                                                        render={({ field }) => <Input {...field} 
                                                        onKeyDown={(e) => {
  // ✅ Allow all Ctrl / Cmd / Alt shortcuts (including Ctrl + R)
  if (e.ctrlKey || e.metaKey || e.altKey) {
    return; 
  }

  // ✅ Allow navigation & control keys
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Tab",
    "Enter",
    "Escape",
    "Home",
    "End",
    "PageUp",
    "PageDown",
    "Shift",
  ];

  if (allowedKeys.includes(e.key)) return;

  // ❌ Block any single character that is NOT a number
  if (e.key.length === 1 && !/^\d$/.test(e.key)) {
    e.preventDefault();
  }
}
}/>}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Form.Item style={{ textAlignLast: 'center' }}>
                                            <Button htmlType="submit" style={{ width: '50%', background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)',
                                                color: 'white',  fontSize: '16px'
                                             }}>
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </div>
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }}>
                        ©2025 Copyright: C-DAC Mumbai. All Rights Reserved
                    </Footer>
                </Layout>
            </Layout>
        </>
    );
}